import { render, staticRenderFns } from "./videoCenter.vue?vue&type=template&id=3f6737e7&scoped=true"
import script from "./videoCenter.vue?vue&type=script&lang=js"
export * from "./videoCenter.vue?vue&type=script&lang=js"
import style0 from "./videoCenter.vue?vue&type=style&index=0&id=3f6737e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6737e7",
  null
  
)

export default component.exports